/** Placeholder until portal invoice API is wired. */
export const PortalInvoicesPage = () => (
  <div className="p-4">
    <h1>My invoices</h1>
    <p>Your invoices will appear here. Contact your account manager for copies in the meantime.</p>
  </div>
);
